import { buildProps } from '@bigin/utils'
import type SkeletonItem from './skeleton-item.vue'
import type { ExtractPropTypes } from 'vue'

export const skeletonItemProps = buildProps({
  variant: {
    type: String,
    values: [
      'circle',
      'rect',
      'h2',
      'h3',
      'h4',
      'text',
      'caption',
      'subtile',
      'p',
      'image',
      'button',
    ],
    default: 'text',
  },
} as const)
export type SkeletonItemProps = ExtractPropTypes<typeof skeletonItemProps>

export type SkeletonItemInstance = InstanceType<typeof SkeletonItem>
